<adapt-dialog [maxWidth]="600"
              [expandable]="false"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>Migrate values</h3>

    <div adapt-dialog-content>
        <ng-container *adaptLoading="loadingStatus">
            @if (migrationData?.ok) {
                <p>All your values are safe to migrate. You may proceed.</p>
            } @else {
                <div>Some of your values have content we cannot automatically migrate. You must remove the following from any value "Ask
                    Yourself" questions:</div>
                <ul>
                    <li>Images</li>
                    <li>Tables</li>
                    <li>Lists (both ordered and unordered)</li>
                </ul>
                @if (teamsToUpdate.size > 0 || migrationData?.organisation) {
                    <div>The following values need to be updated. Clicking the link will open the respective values page in a new tab. If
                        you do not have access to the values, please ask a team member to update them, or contact us for support.</div>
                    <ul>
                        @if (migrationData?.organisation) {
                            <li>
                                <a [href]="organisationValuesRoute$ | async"
                                   target="_blank"
                                   rel="noopener">Organisation values</a>
                            </li>
                        }
                        @for (teamUrlKeyValue of teamsToUpdate | keyvalue; track teamUrlKeyValue) {
                            <li>
                                <a [href]="teamUrlKeyValue.value"
                                   target="_blank"
                                   rel="noopener">
                                    <adapt-team-private-icon
                                                             [team]="teamUrlKeyValue.key"></adapt-team-private-icon>{{ teamUrlKeyValue.key.name }}
                                    team values
                                </a>
                            </li>
                        }
                    </ul>
                }
            }
        </ng-container>

        <button adaptButton="refreshLink"
                [disabled]="loadingStatus"
                [adaptBlockingClick]="migrateValues">Check values</button>

        @if (migrationData?.ok) {
            <div class="mt-3">
                <dx-check-box [value]="checkboxConfirmation"
                              (valueChange)="checkboxConfirmation = $any($event)"
                              data-test="confirm-checkbox"
                              text="Confirm that you want to migrate to behaviour-based values. This cannot be reverted."></dx-check-box>
            </div>
        } @else {
            <p class="mt-3 mb-0">You must update the above values before proceeding.</p>
        }
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="mergePrimary"
                                   saveText="Migrate values"
                                   [saveIsDisabled]="!checkboxConfirmation || !migrationData?.ok"
                                   [saveBlockingClick]="performMigrateValues"
                                   (cancelClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
